import { IMiddleCategoryCropPriceInfo, ISmallCategoryCropPriceInfo } from '../../interfaces/CropTrends.interface';
import { createURLSearchParams } from '../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../common/customAxios';

export interface IGetCropPricesParams {
  searchParam: {
    wholesaleMarketCode: string;
  };
}

export interface IGetCropPrices extends IMiddleCategoryCropPriceInfo {
  subItems: ISmallCategoryCropPriceInfo[];
}

export const getCropPrices = ({ searchParam }: IGetCropPricesParams): Promise<IGetCropPrices[]> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`/crops/prices?${URLSearchParams}`);
};
